var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("招标书详细信息")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "right",
            on: {
              click: function($event) {
                _vm.goBack()
              }
            }
          },
          [_vm._m(0)]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "bidding-container",
        staticStyle: {
          width: "1100px",
          margin: "0 auto",
          padding: "10px",
          "background-color": "#f1f1f1"
        }
      },
      [
        _c("h1", { staticClass: "main-subtitle" }, [
          _c("span", { staticStyle: { "text-align": "left" } }, [
            _vm._v(_vm._s(_vm.callBidDocInfo.title))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bidding-details" },
          [
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("报名截至时间：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.enrollCloseTime))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("资格预审时间：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.openTime))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("投标截止时间：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.closeTime))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("公布结果时间：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.resultPublishTime))
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("联系人：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.contactName))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("联系电话：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.contactTel))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("电子邮箱：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.contactEmail))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("发布时间：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.publishTime))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("申请描述：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.applyDesc))
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("注册资金：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(
                    _vm._s(
                      _vm.callBidDocInfo.reqRegCapital == null
                        ? 0
                        : _vm.callBidDocInfo.reqRegCapital
                    ) + " 万元"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("报名费用：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm.callBidDocInfo.enrollFree
                  ? _c("label", { staticClass: "mr20" }, [_vm._v("免费")])
                  : _c("label", { staticClass: "mr20" }, [
                      _vm._v(_vm._s(_vm.callBidDocInfo.enrollFee) + "  元")
                    ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("成立时间：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(
                    _vm._s(
                      _vm.callBidDocInfo.foundDate == null
                        ? "当前日期"
                        : _vm.callBidDocInfo.foundDate
                    ) + "  之前"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("保证金：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("label", { staticClass: "mr20" }, [
                  _vm._v(_vm._s(_vm.callBidDocInfo.reqDeposit) + "  元")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("招标预算：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm.callBidDocInfo.budgetFlag == 0
                  ? _c("label", { staticClass: "mr20" }, [_vm._v("无预算")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.callBidDocInfo.budgetFlag == 2
                  ? _c("label", { staticClass: "mr20" }, [
                      _vm._v(
                        "固定总额" +
                          _vm._s(_vm.callBidDocInfo.budgetAmount) +
                          "  元"
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title" }, [_vm._v("招标方式：")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm.callBidDocInfo.directed == true
                  ? _c("label", { staticClass: "mr20" }, [_vm._v("定向招标")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.callBidDocInfo.directed == false
                  ? _c("label", { staticClass: "mr20" }, [_vm._v("公开招标")])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._m(3),
              _vm._v(" "),
              _c("table", { staticClass: "custom-tbl" }, [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body align-left" },
                  _vm._l(_vm.callBidReqQualiList, function(bidQuali) {
                    return _c("tr", { staticClass: "row" }, [
                      _c("td", [_vm._v(_vm._s(bidQuali.groupNo))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "align-left" }, [
                        _vm._v(_vm._s(bidQuali.qualiTypeName))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.qualiKindList[bidQuali.qualiKind].text)
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "table-addr" },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: "" },
                                model: {
                                  value: bidQuali.mandatory,
                                  callback: function($$v) {
                                    _vm.$set(bidQuali, "mandatory", $$v)
                                  },
                                  expression: "bidQuali.mandatory"
                                }
                              },
                              [
                                _c("el-radio", { attrs: { label: false } }, [
                                  _vm._v("否")
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: true } }, [
                                  _vm._v("是")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  })
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._m(5),
              _vm._v(" "),
              _c("table", { staticClass: "custom-tbl" }, [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "body align-left" },
                  _vm._l(_vm.callBidDocInfo.staffQualiList, function(
                    staffQuali
                  ) {
                    return _c("tr", { staticClass: "row" }, [
                      _c("td", { staticClass: "align-left" }, [
                        _vm._v(_vm._s(staffQuali.name))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "align-left" }, [
                        _vm._v(_vm._s(staffQuali.qualiName))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "table-addr" }, [
                          staffQuali.qualiLevel == 1
                            ? _c("span", [_vm._v("一级")])
                            : _vm._e(),
                          _vm._v(" "),
                          staffQuali.qualiLevel == 2
                            ? _c("span", [_vm._v("二级")])
                            : _vm._e(),
                          _vm._v(" "),
                          staffQuali.qualiLevel == 3
                            ? _c("span", [_vm._v("三级")])
                            : _vm._e(),
                          _vm._v(" "),
                          staffQuali.qualiLevel == 4
                            ? _c("span", [_vm._v("四级")])
                            : _vm._e(),
                          _vm._v(" "),
                          staffQuali.qualiLevel == 5
                            ? _c("span", [_vm._v("五级")])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(staffQuali.quantity))]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "table-addr" }, [
                          staffQuali.mandatory
                            ? _c("span", [_vm._v("是")])
                            : _c("span", [_vm._v("否")])
                        ])
                      ])
                    ])
                  })
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c(
                "div",
                {
                  staticClass: "content",
                  staticStyle: { "padding-left": "38px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "file-area clearfix" },
                    _vm._l(_vm.callBidDocInfo.callBidFileList, function(
                      file,
                      index
                    ) {
                      return _c("swb-file-item", {
                        attrs: {
                          trackKey: index,
                          fileName: file.name,
                          fileUuid: file.fileUuid,
                          fileBrowseUrl: file.fileBrowseUrl,
                          fileDownloadUrl: file.fileDownloadUrl,
                          fileMd5: file.fileMd5
                        }
                      })
                    })
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content",
                staticStyle: { "padding-left": "38px" }
              },
              [_c("label", [_vm._v(_vm._s(_vm.callBidDocInfo.digest))])]
            ),
            _vm._v(" "),
            false
              ? _c("div", [
                  _vm._m(9),
                  _vm._v(" "),
                  _c("table", { staticClass: "custom-tbl" }, [
                    _vm._m(10),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "body" },
                      _vm._l(_vm.callBidDocInfo.callBidGoodsList, function(
                        callBidGoods
                      ) {
                        return _c("tr", { staticClass: "row" }, [
                          _c("td", [_vm._v(_vm._s(callBidGoods.name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(callBidGoods.quantity))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(callBidGoods.unit))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(callBidGoods.desc))])
                        ])
                      })
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.callBidDocInfo.callBidGoodsList != null &&
            _vm.callBidDocInfo.callBidGoodsList.length > 0
              ? _c("div", { staticClass: "content-caption dashed bg-white" }, [
                  _c("span", [_vm._v("招标商品")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.callBidDocInfo.callBidGoodsList != null &&
            _vm.callBidDocInfo.callBidGoodsList.length > 0
              ? _c("div", [
                  _c("table", { staticClass: "custom-tbl" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "body" },
                      _vm._l(_vm.callBidDocInfo.callBidGoodsList, function(
                        callBidGoods
                      ) {
                        return _c("tr", { staticClass: "row" }, [
                          _c("td", [_vm._v(_vm._s(callBidGoods.name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(callBidGoods.quantity))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(callBidGoods.unit))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(callBidGoods.desc))]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.toPriceComparison(callBidGoods.name)
                                  }
                                }
                              },
                              [_vm._v("比价")]
                            )
                          ])
                        ])
                      })
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.callBidDocInfo.callBidServcList != null &&
            _vm.callBidDocInfo.callBidServcList.length > 0
              ? _c("div", { staticClass: "content-caption dashed bg-white" }, [
                  _c("span", [_vm._v("招标服务")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.callBidDocInfo.callBidServcList != null &&
            _vm.callBidDocInfo.callBidServcList.length > 0
              ? _c("div", [
                  _c("table", { staticClass: "custom-tbl" }, [
                    _vm._m(12),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "body" },
                      _vm._l(_vm.callBidDocInfo.callBidServcList, function(
                        callBidServc
                      ) {
                        return _c("tr", { staticClass: "row" }, [
                          _c("td", [_vm._v(_vm._s(callBidServc.name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(callBidServc.desc))]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.toServcComparison(callBidServc.name)
                                  }
                                }
                              },
                              [_vm._v("比价")]
                            )
                          ])
                        ])
                      })
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.callBidDocInfo.directed
              ? _c("div", { staticClass: "content-caption dashed bg-white" }, [
                  _c("span", [_vm._v("定向商户")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.callBidDocInfo.directed
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: { "line-height": "24px" }
                    },
                    _vm._l(_vm.callBidDocInfo.callBidMerchantList, function(
                      callBidMercht
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "inline-block ellipsis-1 mr20",
                          staticStyle: { width: "200px" }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { title: callBidMercht.merchantName } },
                            [_vm._v(_vm._s(callBidMercht.merchantName))]
                          )
                        ]
                      )
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(13),
            _vm._v(" "),
            _vm.comparedTradeRuleList.length > 0
              ? _c("swb-create-trade-rule", {
                  ref: "swb_create_trade_rule",
                  attrs: {
                    comparedTradeRuleList: _vm.comparedTradeRuleList,
                    type: _vm.type,
                    operate: _vm.operate,
                    forBid: true,
                    forGoods: _vm.forGoods,
                    forServc: _vm.forServc
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-link" }, [
      _c("i", { staticClass: "icon iconfont icon-fanhui2 mr5" }),
      _vm._v("返回")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-caption dashed font18",
        staticStyle: { "background-color": "#fff" }
      },
      [
        _c("span", [
          _c("span", { staticClass: "color-laber" }),
          _vm._v("基本信息")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-caption dashed font18",
        staticStyle: { "background-color": "#fff" }
      },
      [
        _c("span", [
          _c("span", { staticClass: "color-laber" }),
          _vm._v("招标方要求")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("资质类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head align-left" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("招标资质组号")]),
        _vm._v(" "),
        _c("th", [_vm._v("招标资质名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("招标资质类型")]),
        _vm._v(" "),
        _c("th", [_vm._v("是否必须")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("招标要求的人员资质")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head align-left" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("资质类型")]),
        _vm._v(" "),
        _c("th", [_vm._v("类型名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("类型等级")]),
        _vm._v(" "),
        _c("th", [_vm._v("要求数量")]),
        _vm._v(" "),
        _c("th", [_vm._v("是否必须")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("附件信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("内容摘要")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-caption dashed font18",
        staticStyle: { "background-color": "#fff" }
      },
      [
        _c("span", [
          _c("span", { staticClass: "color-laber" }),
          _vm._v("招标商品")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("商品名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("数量")]),
        _vm._v(" "),
        _c("th", [_vm._v("单位")]),
        _vm._v(" "),
        _c("th", [_vm._v("说明")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("商品名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("数量")]),
        _vm._v(" "),
        _c("th", [_vm._v("单位")]),
        _vm._v(" "),
        _c("th", [_vm._v("说明")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("描述")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed bg-white" }, [
      _c("span", [_vm._v("商务条款")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45eb54b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45eb54b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/CallBidDocInfo.vue
// module id = 3331
// module chunks = 0